import { api } from './api';
import { ApiError, ApiResponse } from '@/types/api';

export class BaseApiService<T> {
  protected baseUrl: string;

  constructor(protected endpoint: string) {
    this.baseUrl = `${api.API_URL}/${endpoint}`;
  }

  async fetchAllKeys(filters: Record<string, string> = {}): Promise<ApiResponse<T[]>| ApiError>  {
    console.log('📡 - baseApiService.ts - Iniciando fetchAll:', this.endpoint);
    const queryString = new URLSearchParams(filters).toString();
    const url = `${this.baseUrl+'/keys'}${queryString ? `?${queryString}` : ''}`;
    
    return await api.request<T[]>(url);
  }

  async fetchAll(filters: Record<string, string> = {}): Promise<ApiResponse<T[]>| ApiError>  {
    console.log('📡 - baseApiService.ts - Iniciando fetchAll:', this.endpoint);
    const queryString = new URLSearchParams(filters).toString();
    const url = `${this.baseUrl}${queryString ? `?${queryString}` : ''}`;
    
    return await api.request<T[]>(url);
  }

  async fetchById(id: string): Promise<ApiResponse<T>| ApiError> {
    console.log('📡 - baseApiService.ts - Iniciando fetchById:', id);
    return await api.request<T>(`${this.baseUrl}/${id}`);
  }

  async create(data: Partial<T>): Promise<ApiResponse<T>| ApiError> {
    console.log('📡 - baseApiService.ts - Iniciando create');
    return await api.request<T>(this.baseUrl, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async update(id: string, data: Partial<T>): Promise<ApiResponse<T>| ApiError> {
    console.log('📡 - baseApiService.ts - Iniciando update:', id);
    return await api.request<T>(`${this.baseUrl}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async delete(id: string): Promise<ApiResponse<string>| ApiError> {
    console.log('📡 - baseApiService.ts - Iniciando delete:', id);
    return await api.request<string>(`${this.baseUrl}/${id}`, {
      method: 'DELETE',
    });
  }
} 